export const COLUMN_WIDTHS = {
    name: '30%',
    productKey: '20%',
    locale: '15%',
    status: '10%',
    modifiedDate: '25%',
} as const;

export const COLUMN_HEADERS = {
    name: 'Name',
    productKey: 'Product Key',
    locale: 'Locales',
    status: 'Status',
    modifiedDate: 'Last Modified',
} as const;
